import { Dispatch } from '@reduxjs/toolkit'
import { all } from 'redux-saga/effects'

import { verifyClaimInfoWatcher as claim } from './claim/claim-sagas'
import { previewWatcher } from './upload/preview-sagas'
import { uploadRequestWatcher } from './upload/upload-sagas'

function* RootSaga(dispatch: Dispatch) {
  yield all([
    claim(),
    uploadRequestWatcher(dispatch),
    previewWatcher()
  ])
}

export {
  RootSaga
}
